export default __webpack_public_path__ + "assets/images/success.bb044509.png";